import { render, staticRenderFns } from "./schoolClose.vue?vue&type=template&id=70267f5e&scoped=true&"
import script from "./schoolClose.vue?vue&type=script&lang=js&"
export * from "./schoolClose.vue?vue&type=script&lang=js&"
import style0 from "./schoolClose.vue?vue&type=style&index=0&id=70267f5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70267f5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
